// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2y8rG","detailsBorder":"styles_detailsBorder__1lHJQ"};